@let headerVisible = (headerVisible$ | async);
@if(headerVisible) {
  <sas-header
    [ngStyle]="{ 'visibility': !headerVisible ? 'hidden' : 'visible', 'display': !headerVisible ? 'none' : 'inherit', 'background-color' : 'white' }"
    class="u-relative sas-header"></sas-header>
}

<div class="max-width-container" [ngClass]="headerVisible? 'maxheightvideocall': 'maxheighttotal'">
  <div class="container">
    <!-- router-outlet is a container of our app, used to load lazy load modules -->
    <router-outlet></router-outlet>
  </div>
</div>
<sas-footer></sas-footer>
<!-- MENSAJE POPUP DE VERTICALIDAD -->

@if(!visualWindows) {
    <div id="orientationPopup" class="orientation-msg orientation-msg-with-keyboard">
        <div class="overlay-info-container">
            <h3 class="u-divider-bottom-xl" [translate]="'ORIENTATION_MSG.P1'"></h3>
            <img src="assets/img/diseno/rotate.png" alt="">
            <h4 [translate]="'ORIENTATION_MSG.P2'"></h4>
        </div>
    </div>
}
